import React, { useContext } from 'react'
import {
  ModelCard,
  classnames,
  Context,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import FeaturedPost from './Post'

import { featuredPostsCount } from '../../Static/Constants'

function FeaturedPosts() {
  const { posts } = useContext(Context)
  const featuredPosts = posts.filter((_, i) => i < featuredPostsCount)

  return (
    <div>
      <div className="row blog-posts">
        {featuredPosts.map(
          ({
            image,
            newImage,
            title,
            publishDate,
            categories,
            slug,
          }, index) => {
            return (
              <div
                key={`${title}-${index}`}
                className={classnames(
                  'blog-post-container',
                  index ? 'col-sm-6' : 'col-12'
                )}
              >
                <ModelCard
                  hasShadow
                  customClass={classnames(
                    'featured-blog-post row',
                    index && 'featured-blog-post--small'
                  )}
                >
                  <FeaturedPost
                    titleStyle={`${!index ? 'h2' : 'h5'}`}
                    titleComponent={`${!index ? 'h1' : 'h3'}`}
                    isSmall={!!index}
                    categories={categories}
                    publishDate={publishDate}
                    image={image}
                    newImage={newImage}
                    link={`/blog/${slug}`}
                    title={title}
                    isPostPage
                    showFullTitle={!index}
                  />
                </ModelCard>
              </div>
            )
          }
        )}
      </div>
    </div>
  )
}

export default FeaturedPosts
